import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { Bau365DataAccessExportModule } from '@planone/bau365/data-access-export';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';

import { ExportButtonsComponent } from './export-buttons/export-buttons.component';
import { ExportToggleV2Component } from './export-toggle-v2/export-toggle-v2.component';
import { PageExportComponent } from './page-export/page-export.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    Bau365UiShellModule,
    Bau365DataAccessExportModule,
    SharedUiElementsModule,
    SharedUtilPipelinesModule,
    LetDirective,
    RouterModule.forChild([
      {
        path: ':document_id',
        pathMatch: 'full',
        component: PageExportComponent,
        data: {
          analyticsPageType: 'download',
        },
      },
    ]),
  ],
  exports: [ExportButtonsComponent, ExportToggleV2Component],
  declarations: [ExportButtonsComponent, PageExportComponent, ExportToggleV2Component],
})
export class Bau365FeatureExportModule {}
